// Dependency-free charts (plain CSS bars) — keeps the bundle lean and matches
// the app's hand-rolled CSS design system. Used by the Dashboard page.

export type BarItem = { label: string; value: number; sub?: string };

/** Horizontal labelled bars — good for rankings (top products, low stock…). */
export function HBars({
  items,
  format,
  color = 'var(--color-primary)',
  emptyLabel = 'Aucune donnée',
}: {
  items: BarItem[];
  format: (v: number) => string;
  color?: string;
  emptyLabel?: string;
}) {
  if (items.length === 0) return <div className="chart-empty">{emptyLabel}</div>;
  const max = Math.max(...items.map((i) => Math.abs(i.value)), 1);
  return (
    <div className="hbars">
      {items.map((it, idx) => (
        <div className="hbar-row" key={idx}>
          <div className="hbar-label" title={it.label}>{it.label}</div>
          <div className="hbar-track">
            <div className="hbar-fill" style={{ width: `${(Math.abs(it.value) / max) * 100}%`, background: color }} />
          </div>
          <div className="hbar-value">
            {format(it.value)}
            {it.sub ? <span className="hbar-sub"> {it.sub}</span> : null}
          </div>
        </div>
      ))}
    </div>
  );
}

/** Vertical bars — good for a time series (monthly revenue). */
export function VBars({
  items,
  format,
  color = 'var(--color-accent)',
  emptyLabel = 'Aucune donnée',
}: {
  items: BarItem[];
  format: (v: number) => string;
  color?: string;
  emptyLabel?: string;
}) {
  if (items.length === 0) return <div className="chart-empty">{emptyLabel}</div>;
  const max = Math.max(...items.map((i) => Math.abs(i.value)), 1);
  return (
    <div className="vbars">
      {items.map((it, idx) => (
        <div className="vbar-col" key={idx} title={`${it.label} — ${format(it.value)}`}>
          <div className="vbar-value">{format(it.value)}</div>
          <div className="vbar-track">
            <div className="vbar-fill" style={{ height: `${(Math.abs(it.value) / max) * 100}%`, background: color }} />
          </div>
          <div className="vbar-label">{it.label}</div>
        </div>
      ))}
    </div>
  );
}
